<template>

    <div class='container'>

        <div class='columns' style='margin-top: 1%;'>

            <!-- Main content -->
            <div class='column is-9'>

                <!-- Profile image and user details -->
                <div class='columns'>
                    <div class='column is-4'>
                        <figure class="image is-1by1">
                          <img id="profile-image" class="is-rounded" :src="user.image[0].sizes.profileImage" alt="User profile picture">
                        </figure>
                    </div>
                    <div class='column is-8'>
                        <div style='margin: 10% 0;'>
                            <h2 class='title is-2'>{{user.firstName}} {{user.lastName}}</h2>
                            <h3 class='subtitle is-5'>{{user.aboutMe}}</h3>

                            <div class='columns'>
                                <div class='column is-4'>
                                    <router-link :to="university.routeLink">
                                        <article class="media">
                                          <figure class="media-left">
                                            <p class="image is-48x48">
                                              <img :src="university.image" alt="University icon">
                                            </p>
                                          </figure>
                                          <div class="media-content">
                                            <div class="content">
                                                {{university.name}}<br/>
                                                <small>{{user.accountType.charAt(0).toUpperCase()}}{{user.accountType.slice(1)}}</small>
                                                <!-- <mark><small>B.S. Computer Science<br/>Class of 2017</small></mark> -->
                                            </div>
                                          </div>
                                        </article>
                                    </router-link>
                                </div>
                                <div class='column'>
                                    <nav class="level is-mobile">
                                      <div class="level-item has-text-centered">
                                        <div>
                                          <p class="heading">
                                              <b-icon size="is-small" icon="certificate"></b-icon>
                                              Majors
                                          </p>
                                          <p class="heading">{{majorsString}}</p>
                                        </div>
                                      </div>
                                      <div class="level-item has-text-centered">
                                        <div>
                                          <p class="heading">
                                              <b-icon size="is-small" icon="certificate"></b-icon>
                                              Minors
                                          </p>
                                          <p class="heading">{{minorsString}}</p>
                                        </div>
                                      </div>
                                    </nav>
                                </div>
                            </div>

                            <!-- <div>
                                <img src="/static/images/facebook.svg" width="32" height="32" alt="Facebook profile" />
                                <img src="/static/images/linkedin.svg" width="32" height="32" alt="LinkedIn profile" />
                                <img src="/static/images/twitter.svg" width="32" height="32" alt="Twitter profile" />
                            </div> -->

                            <router-link v-if="getIsOwnProfile()" :to="editProfileRoute">
                                <a class='button is-success is-fullwidth'>Edit profile</a>
                                <br />
                            </router-link>

                        </div>
                    </div>
                </div>

                <!-- User profile content -->
                <div class='box'>
                    <h3 class='title is-4'>Bio</h3>
                    <p>{{user.summary}}</p>

                    <br/><br/>

                    <h3 class='title is-4'>
                        <b-icon icon="lightbulb-on-outline"></b-icon>
                        Interests
                    </h3>
                    <b-taglist>
                        <b-tag v-for="interest in user.interests" :key="interest"
                            type="is-large">{{interest}}
                        </b-tag>
                    </b-taglist>

                    <br/><br/>

                    <template v-if="projectsIsMemberOf.length !== 0">
                        <h3 class='title is-4'>
                            <b-icon icon="account-multiple"></b-icon>
                            Member of
                        </h3>

                        <project-card-list :projects="projectsIsMemberOf" :key="projectsIsMemberOf.length"></project-card-list>

                        <!-- <router-link v-for="obj in projectsIsMemberOf" :key="obj.project.id" :to="obj.routeLink">
                            <article class="media memberOf">
                              <figure class="media-left">
                                <p class="image is-64x64">
                                  <img v-bind:src="obj.project.image[0].sizes.card" alt="Project icon">
                                </p>
                              </figure>
                              <div class="media-content">
                                <div class="content">
                                  <p>
                                    <strong>{{obj.project.name}}</strong><br/>
                                    <small>{{
                                        obj.roles.map(function(role) { return role.name; }).join(', ')
                                    }}</small>
                                  </p>
                                </div>
                              </div>
                          </article>
                        </router-link> -->
                    </template>

                    <br/><br/>

                    <h3 class='title is-4'>
                        <b-icon icon="star"></b-icon>
                        Favorites
                    </h3>
                    <project-card-list :projects="favorites" :key="favorites.length"></project-card-list>

                    <br/><br/>
                </div>

            </div>

            <!-- Sidebar -->
            <div class='column is-3'>

            </div>
        </div>

        <hr/><hr/>

    </div>

</template>

<style scoped>
    #banner-image {
        height: 90px;
        width: 100%;
        background-image: radial-gradient(ellipse farthest-corner at center bottom,rgb(115, 162, 208) 0%,rgb(51, 102, 153) 100%);
        background-color: #336699;
    }
    #profile-image {
        border: 6px SOLID #ccc;
        max-width: 256px;
        max-height: 256px;
        margin: auto;
        /* border-radius: 2px; */
    }
    a > article { color: #4a4a4a; }
    a > .memberOf { color: #222; }
    div.project-member { margin-left: 20px; }
</style>

<script>
export default {
  name: 'User',
  data () {
    return {
        activeTab: 0,
        user: {
          firstName: 'First',
          lastName: 'Last',
          aboutMe: 'This text is a placeholder.',
          image: 'https://placehold.it/96x96',
          editProfileRoute: ''
        },
        university: {
          name: 'University name',
          slug: 'universitySlug',
          image: 'https://placehold.it/96x96'
        },
        projectsIsMemberOf: [],
        favorites: []
    }
  },
  computed: {
    editProfileRoute: function() {
      return '/user/' + this.user.username + '/edit';
    },
    majorsString: function() {
      var majors = [];
      this.user.studies.forEach((study) => {
        if(study.type === 'major') majors.push(study.name);
      });
      return majors.join(', ');
    },
    minorsString: function() {
      var minors = [];
      this.user.studies.forEach((study) => {
        if(study.type === 'minor') minors.push(study.name);
      });
      return minors.join(', ');
    }
  },
  mounted: function() {
    this.$http.get(this.$hostname + '/user/' + this.$route.params.username).then(function(response) {
      this.user = response.body;
    });

    this.$http.get(this.$hostname + '/user/' + this.$route.params.username + '/university').then(function(response) {
      this.university = response.body;
      this.university.routeLink = '/u/' + this.university.slug;
    });

    this.$http.get(this.$hostname + '/user/' + this.$route.params.username + '/favorites').then(function(response) {
      this.favorites = response.body;
    });

    this.$http.get(this.$hostname + '/user/' + this.$route.params.username + '/roles').then(function(response) {
      var roles = response.body,
          projectsIsMemberOf = {
              /*
              1: <project>
                .roles [<role>, <role>]
                .routeLink
              7: <project>
                .roles [<role>]
                .routeLink
              */
          };

      roles.forEach(function(role) {
          if(!projectsIsMemberOf[role.project.id]) {
              projectsIsMemberOf[role.project.id] = role.project;
          }
          // projectsIsMemberOf[role.project.id] = projectsIsMemberOf[role.project.id] || {};
          // projectsIsMemberOf[role.project.id].roles = projectsIsMemberOf[role.project.id].roles || [];
          // projectsIsMemberOf[role.project.id].project = role.project;
          // projectsIsMemberOf[role.project.id].routeLink = '/project/' + role.project.id;
          //
          // projectsIsMemberOf[role.project.id].roles.push(role);
      });

      console.log(Object.values(projectsIsMemberOf));
      // Convert object mapping an id to a project to array of projects
      this.projectsIsMemberOf = Object.values(projectsIsMemberOf);
    });
  },
  methods: {
    getIsOwnProfile: function() {
      return this.$root.user && this.$root.user.username === this.$route.params.username;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/User.vue